/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiLogicalOperator {
    AND = 'AND',
    OR = 'OR'
}


export function instanceOfInternalApiLogicalOperator(value: any): boolean {
    for (const key in InternalApiLogicalOperator) {
        if (Object.prototype.hasOwnProperty.call(InternalApiLogicalOperator, key)) {
            if (InternalApiLogicalOperator[key as keyof typeof InternalApiLogicalOperator] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiLogicalOperatorFromJSON(json: any): InternalApiLogicalOperator {
    return InternalApiLogicalOperatorFromJSONTyped(json, false);
}

export function InternalApiLogicalOperatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiLogicalOperator {
    return json as InternalApiLogicalOperator;
}

export function InternalApiLogicalOperatorToJSON(value?: InternalApiLogicalOperator | null): any {
    return value as any;
}

export function InternalApiLogicalOperatorToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiLogicalOperator {
    return value as InternalApiLogicalOperator;
}

